export function electronicFormat(iban: string) {
  return iban.replace(/[^a-zA-Z0-9]/g, "").toUpperCase();
}

export function amountToUPNString(inputAmount: number) {
  // Convert "4,1" to "4.1" if needed
  const normalized = inputAmount.toString().replace(",", ".");

  // Parse as float
  const amount = parseFloat(normalized);

  // Convert to cents and round
  const amountCents = Math.round(amount * 100);

  // Convert to an 11-digit zero-padded string
  return amountCents.toString().padStart(11, "0");
}

export const buildUpnQrCodeString = ({
  invoiceNumber,
  payerName,
  payerStreet,
  payerCity,
  amount,
  purposeCode,
  paymentPurpose,
  dueDate, // "dd.MM.yyyy" or ""
  recipientIban,
  recipientReference,
  recipientName,
  recipientStreet,
  recipientCity,
}: {
  invoiceNumber: string;
  payerName: string;
  payerStreet: string;
  payerCity: string;
  amount: number; // The payment amount in EUR
  purposeCode: string; // A four-letter code, e.g. "RENT"
  paymentPurpose: string; // A textual description of the payment
  dueDate: string; // "dd.MM.yyyy" format or an empty string if not used
  recipientIban: string; // The recipient's IBAN (no spaces)
  recipientReference: string; // The recipient's reference (e.g. "SI12...")
  recipientName: string; // The recipient's name
  recipientStreet: string; // The recipient's street and number
  recipientCity: string; // The recipient's city
}) => {
  const leadingStyle = "UPNQR"; // 1
  const payerIban = ""; // 2
  const polog = ""; // 3
  const dvig = ""; // 4
  const payerReference = ""; // 5

  // Convert amount to an 11-digit string without decimal point.
  // For example, 81.05 => "0000008105".
  const amountStr = amountToUPNString(amount);

  const paymentDate = ""; // 10 (often empty)
  const urgent = ""; // 11
  const paymentPurposeCode = purposeCode.trim(); // 12 (e.g. "RENT" - 4 BIG letters)
  const paymentPurposeField = paymentPurpose.trim(); // 13
  const paymentDueDate = dueDate; // 14 (e.g. "01.04.2017" or "")

  // recipientIban and recipientReference should be given without spaces
  // and already in correct format.

  const controlSum = "000"; // 20 (initially "000")
  const reserve = ""; // 21

  const fields = [
    leadingStyle, // 1
    payerIban, // 2
    polog, // 3
    dvig, // 4
    payerReference, // 5
    payerName ?? "", // 6
    payerStreet ?? "", // 7
    payerCity ?? "", // 8
    amountStr, // 9
    paymentDate, // 10
    urgent, // 11
    paymentPurposeCode, // 12
    paymentPurposeField, // 13
    paymentDueDate, // 14
    recipientIban, // 15
    recipientReference, // 16
    recipientName, // 17
    recipientStreet, // 18
    recipientCity, // 19
    controlSum, // 20 - placeholder
    reserve, // 21
  ];

  // Compute the control sum:
  // Join all fields with newline
  const dataString = fields.join("\n");

  // Calculate sum of ASCII values
  let sum = 0;
  for (let i = 0; i < dataString.length; i++) {
    sum += dataString.charCodeAt(i);
  }

  // Modulo 1000
  const computed = (sum % 1000).toString().padStart(3, "0");

  // Replace control sum field with the computed value
  fields[19] = computed;

  return fields.join("\n");
};
